"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.suspenseConditionSchema = void 0;
var constants_1 = require("@hobt/constants");
var suspense_condition_code_1 = require("./suspense-condition-code");
exports.suspenseConditionSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['code'],
    properties: {
        code: {
            type: 'string',
            enum: Object.values(suspense_condition_code_1.SuspenseConditionCode),
            errorMessage: 'Should equate to a valid suspense conditions code enum value',
        },
        codeEffectiveTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        codeOverrideTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        codeOverrideUserID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        codeResolvedTimestamp: {
            type: ['string', 'null'],
            pattern: constants_1.dateTimePattern,
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000',
        },
        overrideReasonComment: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 250,
            errorMessage: 'Should be a string with a maximum of 250 characters or null',
        },
    },
};
